import { LOCATION_CHANGE } from 'react-router-redux';

const CLEAR_ELIGIBLE_BANNERS = 'classpass/banner_2/CLEAR_ELIGIBLE_BANNERS';
export const ADD_BANNER = 'classpass/banner_2/ADD';
export const REMOVE_BANNERS = 'classpass/banner_2/REMOVE';
export const REMOVE_CMS_BANNER = 'classpass/banner_2/REMOVE_CMS';

export const clearAllBanners = () => ({ type: CLEAR_ELIGIBLE_BANNERS });
export const removeBanner = (...bannerIds) => ({ type: REMOVE_BANNERS, data: bannerIds });
export const removeCmsBanner = () => ({ type: REMOVE_CMS_BANNER });

export const addBanner = (category, component, props, options = {}) => ({
  type: ADD_BANNER,
  data: {
    id: options.id || (__TEST__ ? 1 : String(Math.round(Math.random() * 100000000))),
    category,
    component,
    props,
    options: {
      priority: 1,
      ...options,
    },
  },
});

export const addAnnouncement = (
  id,
  component,
  props,
  { priority = 1, removeAfterNavigations = null, showBannerOnAllPages = false, suppressible = null, timeout = 0 } = {}
) =>
  addBanner('announcement', component, props, {
    id,
    priority,
    removeAfterNavigations,
    showBannerOnAllPages,
    suppressible,
    timeout,
  });

export const addNotification = (
  component,
  props,
  { priority = 1, timeout = 5000, removeAfterNavigations = 1, ...rest } = {}
) =>
  addBanner('notification', component, props, {
    priority,
    timeout,
    removeAfterNavigations,
    ...rest,
  });

export const addSuccessNotification = (message, options) =>
  addNotification('SuccessNotification', { message }, options);
export const addFailureNotification = (message, options) =>
  addNotification('FailureNotification', { message }, options);
export const addGenericNotification = (message, options) =>
  addNotification('GenericNotification', { message }, options);

export const selectBannerToDisplay = (state, category) => state.banners.find(banner => banner.category === category);
export const selectHasBannersQueued = state => !!state.banners.length;

const initialState = [];

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CLEAR_ELIGIBLE_BANNERS:
      return state.filter(banner => banner.showBannerOnAllPages);
    case ADD_BANNER: {
      const { id, options, ...rest } = action.data;

      const seenIds = {};

      return state
        .concat({
          id,
          ...rest,
          ...options,
          navigationsSinceAdded: 0,
        })
        .reduce((banners, banner) => {
          if (!(banner.id in seenIds)) {
            seenIds[banner.id] = true;
            banners.push(banner);
          }
          return banners;
        }, [])
        .sort((a, b) => b.priority - a.priority);
    }

    case REMOVE_BANNERS:
      return state.filter(banner => !action.data.includes(banner.id));

    case LOCATION_CHANGE:
      return state
        .map(banner => ({
          ...banner,
          navigationsSinceAdded: banner.navigationsSinceAdded + 1,
        }))
        .filter(
          banner => !banner.removeAfterNavigations || banner.navigationsSinceAdded < banner.removeAfterNavigations
        );
    default:
      return state;
  }
}
